import { render, staticRenderFns } from "./CustomGroupSortDemo.vue?vue&type=template&id=0e42d5d0&scoped=true"
import script from "./CustomGroupSortDemo.vue?vue&type=script&lang=js"
export * from "./CustomGroupSortDemo.vue?vue&type=script&lang=js"
import style0 from "./CustomGroupSortDemo.vue?vue&type=style&index=0&id=0e42d5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e42d5d0",
  null
  
)

export default component.exports